let language = {
    ORDER_DETAIL_TITLE: "Order Information",
    ORDER_DETAIL_STATUS: "Order Status",
    ORDER_DETAIL_PAY_TIPS: "(You can pay this order in {{paymentWaitingTime}} minutes after you create this order, or else it will be cancel after {{paymentWaitingTime}} minutes.)",
    ORDER_DETAIL_INVOICE: "INVOICE",
    ORDER_DETAIL_CANCEL: "Cancel",
    ORDER_DETAIL_REORDER: "Reorder",
    ORDER_DETAIL_NUMBER: "Order Number",
    ORDER_DETAIL_CREATION_TIME: "Creation Time",
    ORDER_DETAIL_PAYMENT_TIME: "Payment Time",
    ORDER_DETAIL_SHIPPING: "Shipping Address",
    ORDER_DETAIL_BILLING: "Billing Address",
    ORDER_DETAIL_DELIVERY: "Delivery Method",
    ORDER_DETAIL_PAYMENT: "Payment Method",
    ORDER_DETAIL_TRACKING_NO:"Tracking No",
    ORDER_DETAIL_PAY_FAILED_DES1:"Order payment failed, You can go to",
    ORDER_DETAIL_PAY_FAILED_DES2:"to check the reason."
}

export { language }